import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';
import { HttpParams } from '@angular/common/http';
import { PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'app-items',
    templateUrl: './items.component.html',
    styleUrls: ['./items.component.css'],
    standalone: false
})
export class ItemsComponent implements OnInit {
  page = 1;
  pageSize = 50;

  list_length = 0;
  items: any[] = [];
  services: any[] = [];
  token: any;

  item = {
    name: null,
    description: null,
    quantity: null,
    paid_quantity: 0,
    price: null
  }
  new_item = {
    name: null,
    description: null,
    quantity: null,
    paid_quantity: 0,
    price: null
  }

  filter_config: any;

  update_key: any;
  Swal = 'sweetalert2'

  constructor(public utility: UtilitiesService, private api: ApiService, private modalService: NgbModal, private titleService: Title) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
    this.filter_config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: 0,
      sort: null,
      sort_order: 'asc',
      pageSizeOptions: [5, 10, 25, 100]
    };
  }

  ngOnInit(): void {
    this.titleService.setTitle('Items Selling Page');
    this.getItems();
  }

  open(content: any) {
    this.modalService.open(content);
  }

  edit(content: any, item: any) {
    this.update_key = item.id;
    this.new_item = item;

    this.modalService.open(content);
  }

  getHttpParams() {
    let params = new HttpParams();
    params = params.append('page', this.filter_config.currentPage.toString());
    params = params.append('per_page', this.filter_config.itemsPerPage.toString());
    if (this.filter_config.sort) {
      params = params.append('sort', this.filter_config.sort);
      params = params.append('sort_order', this.filter_config.sort_order);
    }
    if (this.filter_config.queries) {
      params = params.append('queries', this.filter_config.queries);
    }
    return params;
  }
  pageChangeEvent(event: PageEvent) {
    this.filter_config.currentPage = event.pageIndex + 1;
    this.filter_config.itemsPerPage = event.pageSize;
    this.getItems();
  }

  async getItems() {
    const sub = this.api.get('items/', this.token, { params: this.getHttpParams() }).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.items = objects.items;
        this.list_length = this.items.length;
      },
      async error => { }
    );

    sub.add(() => { });
  }

  async OnSubmit() {
    let body = {
      'name': this.item.name,
      'description': this.item.description,
      'quantity': this.item.quantity,
      'paid_quantity': this.item.paid_quantity,
      'price': this.item.price
    }

    this.api.post("items/", body, this.token).subscribe(
      async data => {
        this.getItems();
        Swal.fire({
          title: 'Success!',
          text: 'Added Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  async OnUpdate(key: any) {
    let body = {
      'name': this.new_item.name,
      'description': this.new_item.description,
      'quantity': this.new_item.quantity,
      'paid_quantity': this.new_item.paid_quantity,
      'price': this.new_item.price
    }

    this.api.update("items/" + key, body, this.token).subscribe(
      async data => {
        this.getItems();
        Swal.fire({
          title: 'Success!',
          text: 'Updated Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  async onDelete(key: any) {
    if (confirm("Delete this item?")) {
      this.api.delete('items/' + key, this.token).subscribe(
        async data => {
          this.getItems();
          Swal.fire({
            title: 'Success!',
            text: 'Deleted Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );
    }
  }
}
